let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j2ffl")).then(() => parcelRequire('6Hcwg'));